import { useSignal, useSignalEffect } from "@preact/signals-react";
import { useTranslation } from "react-i18next";
import { OptionButtons } from "components/Form/OptionButtons";
import { ASSESSMENT_SUBJECT_SELF } from "components/Assessment/Subject";

export function AssessmentDiscussWithOthers({
  assessmentSubject,
  defaultOption = null,
  onAnswer = () => {},
  className = '',
}) {
  const { t } = useTranslation();
  const hasDiscussed = useSignal(defaultOption);
  useSignalEffect(() => {
    onAnswer(hasDiscussed.value);
  });

  return (
    <div className={className}>
      <p>{t(
        assessmentSubject.value === ASSESSMENT_SUBJECT_SELF
          ? 'have you discussed with family or others'
          : 'have the assessment subject discussed with family or others'
      )}</p>
      <OptionButtons
        className="options"
        defaultOption={hasDiscussed.value}
        options={[
          { label: t('yes, i have'), value: true },
          { label: t('no, i have not'), value: false },
        ]}
        onSelect={(value) => onAnswer(value)}
      />
    </div>
  )
}

export default AssessmentDiscussWithOthers;